import { PermissionsLanguage } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { IsStringEmpty } from '../../../NonReact/utils/GlobalFunctions'
import { ALL_VALUE } from '../../Common/API/ItemsGetters'
import { SelectItem, SelectOption } from '../../Common/Components/Selects/Types'
import { SERVER_ALL_VALUE } from '../Constants'

/**
 * Constructs the default permissions for the permissions tab.
 */
export class PermissionsDefaults {
    public static INSTANCE: PermissionsDefaults

    private language: CLanguageHandler

    constructor(language: CLanguageHandler) {
        this.language = language

        this.language.loadBundle('PermissionsLanguage')
    }

    public getAllTelServersOption(): SelectOption<number> {
        return {
            label: this.language.get(PermissionsLanguage.AllTelServer),
            value: ALL_VALUE
        }
    }

    public getAnyPartitionOption(): SelectOption<number> {
        return {
            label: this.language.get(PermissionsLanguage.AnyPartition),
            value: ALL_VALUE
        }
    }

    public getAnyDevice(agent?: string): SelectItem {
        if (!IsStringEmpty(agent) && agent !== SERVER_ALL_VALUE) {
            return {
                label: this.language.get(PermissionsLanguage.AnyDeviceForAgent),
                value: SERVER_ALL_VALUE
            }
        }

        return {
            label: this.language.get(PermissionsLanguage.AnyDevices),
            value: SERVER_ALL_VALUE
        }
    }

    public getAnyAgent(device?: string): SelectItem {
        if (!IsStringEmpty(device) && device !== SERVER_ALL_VALUE) {
            return {
                label: this.language.get(PermissionsLanguage.AnyAgentForDevice),
                value: SERVER_ALL_VALUE
            }
        }

        return {
            label: this.language.get(PermissionsLanguage.AnyAgents),
            value: SERVER_ALL_VALUE
        }
    }

    public static getInstance(language: CLanguageHandler): PermissionsDefaults {
        if (!this.INSTANCE) {
            this.INSTANCE = new PermissionsDefaults(language)
        }

        return this.INSTANCE
    }
}
